// @givmo/app-charity — the module whose FRAME the current page wears, as the shell's ONE sidebar
// computation answered it (Org Machinery OM-28 review fold). The company console's twin.
//
// The composed settings page leads with the section of the module it was opened from ("Board
// settings"). It used to work that module out for itself from its origin; since the origin rides
// the page's ADDRESS, which anyone can copy, bookmark or edit, the page now reads the frame the
// shell's sidebar actually rendered (`Sidebar.frame`, provided around the page in `app-shell.tsx`)
// — so the sidebar, the bar's word and the page's module section can never name two modules.
// `null` where no module frames the page: an Admin Console origin, the Organization section alone.

import { createContext, use } from 'react';

export const ConsoleFrameContext = createContext<string | null>(null);

/** The module whose frame the current page wears, or `null` when none does. */
export function useConsoleFrame(): string | null {
  return use(ConsoleFrameContext);
}
